export * from './transmission-readings.component';
export * from './transmission-readings.module';
